export default class ValueBtn {
    constructor() {
        const inner = document.querySelector("section.value .inner");
        const btn = document.querySelector("section.value .btnWrap button");
        let flg = false;
        if(btn){
        btn.addEventListener("click", function(){
            if(flg === false){
                flg = true;
                inner.style.height = "auto"
                btn.classList.add("act");
            }else if(flg === true){
                flg = false;
                inner.style.height = "680px"
                btn.classList.remove("act");
            }
        })
    }}
  }